<template>
  <div id="app" :style="{'min-width': isPhone ? 'auto': '1200px'}" :class="{appPhone: isPhone}">
      <Header @jump="jump" :tabIndex="index"/>
      <router-view></router-view>
      <Footer @jump="jump"/>
  </div>
</template>

<script>
    import Header from "./components/header.vue";
    import Footer from "./components/footer.vue";
    import {getPCorPhone} from "./tools";
    export default {
        name: "app",
        data() {
            return {
                index: 0,
                isPhone: false
            };
        },
        methods: {
            jump(link, index, id){
                this.$router.push({path: link, query: {id: id}});
                this.index = index;
            }
        },
        components: { Header, Footer},
        created() {
            this.isPhone = getPCorPhone();
        }
    };
</script>

<style lang="scss">
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: white;
}
.page{
    width: 80%;
	margin: 0 auto;
    height: 100%;
}
.appPhone .page{
	width: 100%;
}

body, html{
    font-size: calc(1vw / 1.2);
    -webkit-text-size-adjust:none;
}
*{
    padding: 0;
    margin: 0;
}
ul, li{
    list-style-type: none;
}
.base{
    img{
        width: 100%;
    }
}
.title-box{
    color: #1B5AA7;
    position: absolute;
    width: 100%;
    text-align: center;
    font-size: 3rem;
    font-weight: 600;
    padding-top: 2rem;
    .title{
        position: relative;
        &:after{
            content: '';
            background: #1B5AA7;
            position: absolute;
            bottom: -1rem;
            height: 0.5rem;
            width: 100%;
            left: 0;
            border-radius: 0.5rem;
        }
    }
}
</style>
